import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import logo from "../../assets/images/logo.png";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { getToken, getFromStorage, setToken, setToStorage } from "../../services/authService"

import { Link, NavLink } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'

MobileHeader.propTypes = {};

function MobileHeader({ handleMobile }) {

  const [userToken, setUserToken] = useState("");

  const token = async () => {

    const userToken = getToken();

    if (!userToken) return;

    setUserToken(userToken);
  };

  useEffect(() => {
    token();
  }, []);

  return (
    <>
      <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

          <Tabs className="tf-tab">
            <div className="content-tab">
              <TabPanel className="categories animation-tab">
                <div className="sub-categorie-mobile">
                  <ul className="pop-up">
                    <li className="categories-mobile">
                      <Link to="/">
                        Home
                      </Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/latest">
                        Latest
                      </Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/business">
                        Business
                      </Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/life-in-the-uk">
                        Life in the UK
                      </Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/family-sponsorship">
                        Family Sponsorship
                      </Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/study">
                        Study
                      </Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/work">Work</Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/visit">Visit</Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/citizenship">Citizenship</Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/news/category/settling-in-the-uk">Settling in the UK</Link>
                    </li>
                    <li className="categories-mobile">
                      <Link to="/jobs">Sponsorship Jobs</Link>
                    </li>
                  </ul>
                </div>
              </TabPanel>
            </div>
          </Tabs>

          {!userToken && <div className="header-customize-item button">
            <Link to="/login">Login</Link>
          </div>}

          <div className="mobile-footer">
            <div className="wd-social d-flex aln-center">
              <ul className="list-social d-flex aln-center">
                <li>
                  <Link to="https://www.facebook.com/profile.php?id=61587216466717">
                    <i className="icon-facebook"></i>
                  </Link>
                </li>
                <li>
                  <Link to="https://www.linkedin.com/company/united-kingdom-immigration-council-news-ukicnews">
                    <i className="icon-linkedin2"></i>
                  </Link>
                </li>
                <li>
                  <Link to="https://x.com/ukicnews173216">
                    <i className="icon-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link to="https://www.instagram.com/ukicnews/">
                    <i className="icon-instagram1"></i>
                  </Link>
                </li>
                {/* <li>
                  <Link to="#">
                    <i className="icon-youtube"></i>
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileHeader;
